export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "create_your": "మీ జన్మతేదీ ఆధారంగా",
    "numerology": "మీ న్యూమరాలజీ రిపోర్ట్ రూపొందించబడుతుంది.", 
    "numbers_reveal_destiny": "సంఖ్యలు మీ విధిని వెల్లడిస్తాయి",
    "numerology_description": "మీ జీవిత మార్గం, విధి సంఖ్య, వ్యక్తిత్వ లక్షణాలు మరియు దైవిక సంఖ్యల ప్రభావాలను తెలియజేసే సమగ్ర న్యూమరాలజీ విశ్లేషణతో, జీవితంలో సంఖ్యల రహస్య శక్తిని అన్వేషించండి.",

    // Service Information
    "enter_details_for_numerology": "న్యూమరాలజీ కోసం మీ వివరాలను నమోదు చేయండి",
    "complete_numerology_analysis": "పూర్ణ న్యూమరాలజీ విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_numerology_analysis_note": "మీ సంఖ్యా బ్లూప్రింట్‌లో లోతైన అధ్యయనం మరియు మీ జీవితంలోని దైవిక గణిత నమూనాలను కనుగొనండి",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "name_vibration_analysis": "మీ పేరు మీ విధిని ప్రభావితం చేసే నిర్దిష్ట సంఖ్యా కంపనలను కలిగి ఉంటుంది",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "birth_date_life_path_number": "మీ జన్మ తేదీ మీ జీవిత మార్గ సంఖ్య మరియు ప్రధాన జీవిత ఉద్దేశ్యాన్ని వెల్లడిస్తుంది",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ న్యూమరాలజీ విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Numerology Features
    "life_path_number_analysis": "జీవిత మార్గ సంఖ్య విశ్లేషణ",
    "destiny_number_insights": "విధి సంఖ్య అంతర్దృష్టులు",
    "personality_number_traits": "వ్యక్తిత్వ సంఖ్య లక్షణాలు",
    "lucky_numbers_and_colors": "అదృష్ట సంఖ్యలు మరియు రంగులు",
    "career_compatibility_numbers": "కెరీర్ అనుకూలత సంఖ్యలు",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ న్యూమరాలజీ విశ్లేషణలో ఉన్నవి",
    "complete_numerology_chart": "పూర్తి న్యూమరాలజికల్ చార్ట్",
    "core_numbers_analysis": "ప్రధాన సంఖ్యల విభజన",
    "personal_year_predictions": "వ్యక్తిగత సంవత్సర అంచనా",
    "compatibility_insights": "సంఖ్యా అనుకూలత గైడ్",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా న్యూమరాలజీ విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "numerology_analysis_processing": "మీ న్యూమరాలజీ విశ్లేషణ మా నిపుణ న్యూమరాలజిస్ట్‌లచే గణనలు చేయబడుతోంది. మీ సంఖ్యా బ్లూప్రింట్‌పై వివరణాత్మక అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_12_hours_delivery_note": "మీ వివరణాత్మక న్యూమరాలజీ నివేదిక 12 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ న్యూమరాలజీ విశ్లేషణ ప్యాకేజ్",
    "detailed_numerology_report": "సమగ్ర న్యూమరాలజీ నివేదిక (PDF)",
    "life_path_destiny_analysis": "జీవిత మార్గ మరియు విధి సంఖ్య విశ్లేషణ",
    "personal_numbers_meanings": "వ్యక్తిగత సంఖ్యలు మరియు వాటి అర్థాలు",
    "lucky_elements_guidance": "అదృష్ట అంశాలు మరియు మార్గదర్శనం",
    "annual_forecast_insights": "వార్షిక న్యూమరాలజికల్ అంచనా",

    // Visual Content
    "sample_numerology_analysis": "నమూనా న్యూమరాలజీ విశ్లేషణ",
    "life_path_number": "జీవిత మార్గ సంఖ్య",
    "sample_life_path_description": "అన్వేషకుడు - విశ్లేషణాత్మక, ఆధ్యాత్మిక మరియు అంతర్ముఖ స్వభావం",
    "sample_numerology_description": "వివరణాత్మక అంతర్దృష్టులతో మీ వ్యక్తిగత సంఖ్యా విశ్లేషణ మునుజూపు",
    "core_numbers": "ప్రధాన సంఖ్యలు",

    // Core Number Types
    "life_path": "జీవిత మార్గం",
    "destiny": "విధి",
    "personality": "వ్యక్తిత్వం",
    "soul_urge": "ఆత్మ కోరిక",
    "birthday": "జన్మదినం",
    "maturity": "పరిపక్వత",

    // Status & Processing
    "your_numerology_analysis_status": "మీ న్యూమరాలజీ విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ సంఖ్యలను గణిస్తోంది",
    "analysis_processing_message": "మా న్యూమరాలజీ నిపుణులు మీ సంఖ్యా నమూనాలను విశ్లేషిస్తూ మీ వ్యక్తిగత అంతర్దృష్టులను తయారు చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_12_hours": "12 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "న్యూమరాలజీ మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Core Numerology Numbers
    "life_path_number": "జీవిత మార్గ సంఖ్య",
    "destiny_number": "విధి సంఖ్య",
    "personality_number": "వ్యక్తిత్వ సంఖ్య",
    "soul_urge_number": "ఆత్మ కోరిక సంఖ్య",
    "birthday_number": "జన్మదిన సంఖ్య",
    "maturity_number": "పరిపక్వత సంఖ్య",
    "expression_number": "వ్యక్తీకరణ సంఖ్య",
    "heart_desire_number": "హృదయ కోరిక సంఖ్య",

    // Number Meanings (1-9)
    "number_1_meaning": "నాయకత్వం, స్వతంత్రత, మార్గదర్శకుడు",
    "number_2_meaning": "సహకారం, భాగస్వామ్యం, దౌత్యం",
    "number_3_meaning": "సృజనాత్మకత, వ్యక్తీకరణ, కమ్యూనికేషన్",
    "number_4_meaning": "స్థిరత్వం, కష్టపడి పని, పునాది",
    "number_5_meaning": "స్వేచ్ఛ, సాహసం, మార్పు",
    "number_6_meaning": "పోషణ, బాధ్యత, వైద్యం",
    "number_7_meaning": "ఆధ్యాత్మికత, విశ్లేషణ, జ్ఞానం",
    "number_8_meaning": "భౌతిక విజయం, అధికారం, సాధన",
    "number_9_meaning": "మానవతావాదం, పూర్తి, సేవ",

    // Master Numbers
    "master_number_11": "మాష్టర్ నంబర్ 11 - అంతర్దృష్టి మరియు ప్రేరణ",
    "master_number_22": "మాష్టర్ నంబర్ 22 - మాష్టర్ బిల్డర్",
    "master_number_33": "మాష్టర్ నంబర్ 33 - మాష్టర్ గురువు",

    // Personality & Character Analysis
    "core_personality_traits": "ప్రధాన వ్యక్తిత్వ లక్షణాలు",
    "strengths_and_talents": "సహజ బలాలు మరియు ప్రతిభలు",
    "challenges_to_overcome": "అధిగమించవలసిన సవాళ్లు",
    "life_lessons": "ప్రధాన జీవిత పాఠాలు",
    "inner_motivation": "అంతర్గత ప్రేరణలు",
    "outer_expression": "ఇతరులు మిమ్మల్ని ఎలా చూస్తారు",

    // Life Path Analysis
    "life_purpose": "జీవిత ఉద్దేశ్యం మరియు మిషన్",
    "career_guidance": "కెరీర్ మార్గ మార్గదర్శనం",
    "relationship_patterns": "సంబంధ నమూనాలు",
    "financial_tendencies": "డబ్బు మరియు ఆర్థిక ధోరణులు",
    "health_insights": "ఆరోగ్యం మరియు క్షేమం అంతర్దృష్టులు",
    "spiritual_journey": "ఆధ్యాత్మిక అభివృద్ధి మార్గం",

    // Compatibility Analysis
    "love_compatibility": "మీ ప్రేమ జీవితం",
    "friendship_compatibility": "మిత్రత్వ అనుకూలత",
    "business_compatibility": "వ్యాపార భాగస్వామ్య అనుకూలత",
    "family_dynamics": "కుటుంబ సంబంధ డైనామిక్స్",
    "compatible_numbers": "అత్యంత అనుకూలమైన సంఖ్యలు",
    "challenging_numbers": "సంభావ్య సవాలు కలిగించే సంఖ్యలు",

    // Lucky Elements
    "lucky_numbers": "వ్యక్తిగత అదృష్ట సంఖ్యలు",
    "lucky_colors": "మంగళకర రంగులు",
    "lucky_days": "అనుకూలమైన రోజులు",
    "lucky_gemstones": "లాభదాయకమైన రత్నాలు",
    "lucky_directions": "అనుకూలమైన దిశలు",
    "lucky_metals": "మంగళకరమైన లోహాలు",

    // Personal Year Analysis
    "current_personal_year": "ప్రస్తుత వ్యక్తిగత సంవత్సరం",
    "personal_year_theme": "సంవత్సర థీమ్ మరియు దృష్టి",
    "monthly_guidance": "నెల వారీ మార్గదర్శనం",
    "opportunities_this_year": "ప్రధాన అవకాశాలు",
    "challenges_this_year": "సంభావ్య సవాళ్లు",
    "recommendations_this_year": "సంవత్సర-నిర్దిష్ట సిఫార్సులు",

    // Name Analysis
    "name_numerology": "పేరు న్యూమరాలజీ విశ్లేషణ",
    "first_name_vibration": "మొదటి పేరు కంపనలు",
    "last_name_influence": "ఇంటిపేరు ప్రభావం",
    "full_name_power": "పూర్తి పేరు శక్తి",
    "nickname_effects": "ముద్దుపేరు ప్రభావాలు",
    "name_change_suggestions": "పేరు అనుకూలీకరణ సూచనలు",

    // Birth Date Analysis
    "birth_date_significance": "జన్మ తేదీ ప్రాధాన్యత",
    "day_vibration": "దిన సంఖ్య ప్రభావం",
    "month_influence": "జన్మ నెల ప్రభావం",
    "year_energy": "జన్మ సంవత్సర శక్తి",
    "complete_birth_pattern": "పూర్తి జన్మ నమూనా విశ్లేషణ",

    // Karmic Numbers
    "karmic_debt_numbers": "కర్మ రుణ సంఖ్యలు",
    "karmic_lessons": "కర్మ జీవిత పాఠాలు",
    "soul_contracts": "ఆత్మ ఒప్పందాలు మరియు ఒప్పందాలు",
    "past_life_influences": "పూర్వ జన్మ సంఖ్యా ప్రభావాలు",

    // Cycles & Periods
    "life_cycles": "ప్రధాన జీవిత చక్రాలు",
    "pinnacle_numbers": "శిఖర కాలం సంఖ్యలు",
    "challenge_numbers": "సవాలు కాలం సంఖ్యలు",
    "personal_months": "వ్యక్తిగత మాసిక చక్రాలు",

    // Advanced Analysis
    "master_numbers_significance": "మీ చార్ట్‌లోని మాష్టర్ నంబర్లు",
    "missing_numbers": "తప్పిపోయిన సంఖ్యల విశ్లేషణ",
    "repeated_numbers": "పునరావృత సంఖ్యల ప్రాధాన్యత",
    "intensity_table": "సంఖ్యా తీవ్రత విశ్లేషణ",

    // Practical Applications
    "best_dates_for_decisions": "ముఖ్యమైన నిర్ణయాలకు అత్యుత్తమ తేదీలు",
    "timing_for_ventures": "కొత్త వెంచర్లకు అనువైన సమయం",
    "home_address_analysis": "ఇంటి చిరునామా న్యూమరాలజీ",
    "phone_number_analysis": "ఫోన్ నంబర్ కంపనలు",
    "choosing_baby_names": "న్యూమరాలజికల్ శిశువు పేరు మార్గదర్శనం",

    // Remedies & Recommendations
    "numerical_remedies": "న్యూమరాలజికల్ పరిహారాలు",
    "color_therapy": "రంగు చికిత్స సిఫార్సులు",
    "gemstone_suggestions": "రత్న సిఫార్సులు",
    "mantras_for_numbers": "సంఖ్య-నిర్దిష్ట మంత్రాలు",
    "meditation_techniques": "సంఖ్యా ధ్యాన పద్ధతులు",

    // Business & Career
    "business_name_analysis": "వ్యాపార పేరు న్యూమరాలజీ",
    "career_number_alignment": "కెరీర్-సంఖ్య అమరిక",
    "partnership_numbers": "వ్యాపార భాగస్వామ్య సంఖ్యలు",
    "investment_timing": "పెట్టుబడి సమయ మార్గదర్శనం",
    "product_launch_dates": "ఉత్పత్తి లాంచ్ తేదీ ఎంపిక"
};
